import { useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { Button, Card, Col, Form, Input, Row, Select, Space, Spin } from 'antd';

import { handlePostApi, handleUpdatePostApi } from '@/api/crud';
import {
  branchApiEndpoints,
  companyAccessEndpoints,
  roleApiEndpoints,
} from '@/api/endpoints';

import { useFetch } from '@/hooks';
import { optionSearchFunction } from '@/utils/common';
import { rules } from '@/utils/validation/FormValidation';
import GlobalDivider from '@/utils/divider/GlobalDivider';

const CreateRole = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [branchList, setBranchList] = useState([]);
  const [form] = Form.useForm(); //Form hooks for managing hooks state
  const navigate = useNavigate();
  const abortController = new AbortController();

  useEffect(() => {
    if (id) {
      (async function () {
        const signal = abortController.signal;

        const res = await roleApiEndpoints.retrieve(id, signal);
        if (res?.data?.data) {
          const role = res.data.data;
          form.setFieldValue('roleType', role.roleType);
          form.setFieldValue('companyId', role.companyId);
          handleBranchFetch(role.companyId);
          form.setFieldValue('branchId', role.branchId);
        }
      })();

      return () => {
        abortController.abort();
      };
    }
  }, [id]);

  const navigateToRoleList = () => {
    navigate('/role/list/');
  };

  const { data: companyList } = useFetch(companyAccessEndpoints.retrieveList);

  async function handleBranchFetch(companyId) {
    form.setFieldsValue({ branchId: '' });
    const { data } = await branchApiEndpoints.companyWiseBranch(companyId);
    setBranchList(data?.data);
  }

  return (
    <>
      <section className="">
        <Card>
          <Form
            form={form}
            className="username"
            layout="vertical"
            onFinish={(value) =>
              id
                ? handleUpdatePostApi(
                    id,
                    roleApiEndpoints.update,
                    value,
                    setLoading,
                    form,
                    () => {},
                    navigateToRoleList,
                  )
                : handlePostApi(
                    roleApiEndpoints.create,
                    value,
                    setLoading,
                    form,
                  )
            }
          >
            <Spin spinning={loading}>
              <GlobalDivider name={id ? 'Update Role' : 'Create Role'} />

              <div>
                <Row gutter={[24, 0]}>
                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Select Company"
                      name="companyId"
                      validateTrigger="onChange"
                      rules={[
                        {
                          required: true,
                          message: 'please select a company',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Company"
                        filterOption={optionSearchFunction}
                        disabled={id}
                        options={companyList?.map((item) => {
                          return {
                            value: item?.referenceId,
                            label: item?.name,
                          };
                        })}
                        onChange={handleBranchFetch}
                      />
                    </Form.Item>{' '}
                  </Col>

                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Select Branch"
                      name="branchId"
                      validateTrigger="onChange"
                      rules={[
                        {
                          required: true,
                          message: 'please select branch',
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        placeholder="Select Branch"
                        disabled={branchList.length === 0 || id}
                        filterOption={optionSearchFunction}
                        options={branchList?.map((item) => {
                          return {
                            value: item?.referenceId,
                            label: item?.branchName,
                          };
                        })}
                      />
                    </Form.Item>{' '}
                  </Col>

                  <Col xs={{ span: 24 }} lg={{ span: 8 }}>
                    <Form.Item
                      label="Role"
                      name="roleType"
                      rules={rules.textOnly}
                      hasFeedback
                      validateTrigger="onChange"
                    >
                      <Input placeholder="Role" autoComplete="off" />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div style={{ textAlign: 'right' }}>
                <Space size="large">
                  <Button type="primary" htmlType="submit" disabled={loading}>
                    {id ? 'UPDATE' : 'CREATE'}
                  </Button>

                  <Button type="primary" danger onClick={() => navigate(-1)}>
                    CANCEL
                  </Button>
                </Space>
              </div>
            </Spin>
          </Form>
        </Card>
      </section>
    </>
  );
};

export default CreateRole;
